"use client";

import { Reveal } from "@/components/motion";
import { FounderQuoteCard } from "@/components/about/FounderQuoteCard";
import type { AboutIntroContent } from "@/lib/api-types";

interface AboutIntroSectionProps {
  intro: AboutIntroContent;
}

export function AboutIntroSection({ intro }: AboutIntroSectionProps) {
  const mission = intro.paragraphs[0] ?? intro.lead;

  return (
    <section className="site-section">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <h2 className="sr-only">{intro.headline}</h2>
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal className="order-2 lg:order-1">
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--site-accent)]">
              Our mission
            </p>
            <p className="max-w-prose text-lg leading-relaxed text-[var(--site-muted)] md:text-xl">
              {mission}
            </p>
          </Reveal>

          <div className="order-1 lg:order-2">
            <FounderQuoteCard card={intro.founderCard} />
          </div>
        </div>
      </div>
    </section>
  );
}
